import { useQuery } from '@tanstack/react-query';
import { defaultParamsSerializer, handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import { Paginated } from '@/lib/interface';
import type { IAdminMessage } from '@/interfaces';
import routes from '@/lib/routes';

type TListParams = {
  page?: number;
  limit?: number;
};

export const useRequestGetAdminMessages = (params: TListParams = {}) => {
  const { isFetching, data, error } = useQuery({
    queryKey: [routes.api.adminMessagesList, params],
    queryFn: () =>
      apiClient
        .get<Paginated<IAdminMessage>>(routes.api.adminMessagesList, params, {
          paramsSerializer: defaultParamsSerializer
        })
        .then(handleApiResponse),
    staleTime: 60_000
  });

  return {
    isLoading: isFetching,
    data,
    messages: data?.data ?? [],
    pagination: data?.pagination,
    error
  };
};

export const useRequestGetAdminMessage = (id: string | null) => {
  const { isFetching, data, error } = useQuery({
    queryKey: [routes.api.adminMessageById, id],
    queryFn: () =>
      apiClient
        .get<IAdminMessage>(routes.api.adminMessageById(id!))
        .then(handleApiResponse),
    enabled: id != null
  });

  return {
    isLoading: isFetching,
    message: data,
    error
  };
};
